import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BG = 'https://readdy.ai/api/search-image?query=serene%20abstract%20warm%20gradient%20background%2C%20soft%20champagne%20gold%20and%20deep%20navy%20blue%20tones%2C%20gentle%20bokeh%20light%20orbs%2C%20elegant%20luxury%20atmosphere%2C%20smooth%20texture%2C%20high-end%20medical%20consultation%20ambiance%2C%20no%20people%2C%20minimalist%20artistic%20backdrop&width=1400&height=500&seq=cta-banner-001&orientation=landscape';

export default function CtaBanner() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img src={BG} alt="" className="w-full h-full object-cover object-center" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d2137]/90 via-[#0d2137]/80 to-[#0d2137]/70"></div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#c9a96e]/60 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#c9a96e]/60 to-transparent"></div>
      <div className="absolute -top-16 -right-16 w-72 h-72 rounded-full bg-[#c9a96e]/8 blur-3xl pointer-events-none"></div>
      <div className="absolute -bottom-16 -left-16 w-72 h-72 rounded-full bg-[#c9a96e]/8 blur-3xl pointer-events-none"></div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-sm text-white/80 text-xs font-medium tracking-widest uppercase px-4 py-1.5 rounded-full mb-6">
          <span className="w-1.5 h-1.5 rounded-full bg-[#c9a96e] animate-pulse"></span>
          {t('cta_label')}
        </div>

        <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
          {t('cta_title1')}
          <br />
          <span className="text-[#c9a96e]">{t('cta_title2')}</span>
        </h2>

        <p className="text-white/70 text-sm md:text-base max-w-xl mx-auto mb-10 leading-relaxed">
          {t('cta_desc')}
        </p>

        {/* CTA */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="group flex items-center gap-2 bg-[#c9a96e] hover:bg-[#b8944f] text-white font-bold px-10 py-4 rounded-full transition-all hover:scale-105 whitespace-nowrap cursor-pointer text-base"
          >
            <i className="ri-calendar-check-line text-lg"></i>
            {t('cta_btn1')}
            <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
          </Link>
          <Link
            to="/cases"
            className="flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 backdrop-blur-sm text-white font-semibold px-8 py-4 rounded-full transition-all whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-award-line"></i>
            {t('cta_btn2')}
          </Link>
        </div>

        {/* Trust badges */}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {[
            { icon: 'ri-shield-check-line', key: 'cta_badge1' },
            { icon: 'ri-lock-line', key: 'cta_badge2' },
            { icon: 'ri-global-line', key: 'cta_badge3' },
            { icon: 'ri-customer-service-line', key: 'cta_badge4' },
          ].map((b) => (
            <div key={b.key} className="flex items-center gap-2 text-white/60 text-xs">
              <i className={`${b.icon} text-[#c9a96e] text-base`}></i>
              <span>{t(b.key)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}